import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetInstallationBackupsResData } from "./GetInstallationBackupsResData";

const ENDPOINT = "/caosconfiguration/backup";

export class GetInstallationBackupsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetInstallationBackupsReqData = null;

    constructor(installationName: string) {
        super();
        this.params = new GetInstallationBackupsReqData(installationName);
    }

    public async execute(): Promise<GetInstallationBackupsResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetInstallationBackupsResData(res);
    }
}

export class GetInstallationBackupsReqData {
    installationName: string;

    constructor(installationName: string) {
        this.installationName = installationName;
    }
}
